import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=0fe198e2&scoped=true&"
import script from "./goodsInfo.vue?vue&type=script&lang=js&"
export * from "./goodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=0fe198e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe198e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe198e2')) {
      api.createRecord('0fe198e2', component.options)
    } else {
      api.reload('0fe198e2', component.options)
    }
    module.hot.accept("./goodsInfo.vue?vue&type=template&id=0fe198e2&scoped=true&", function () {
      api.rerender('0fe198e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/goodsInfo.vue"
export default component.exports